import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslationService } from '@sdbn/common';


@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DictionaryFieldComponent),
            multi: true,
        },
    ],
    selector: 'app-dictionary-field',
    templateUrl: './dictionary-field.component.html',
    styleUrls: ['./dictionary-field.component.scss'],
    standalone: false
})
export class DictionaryFieldComponent {

  @Input() dictionaryKey!: string;

  constructor(
    public translationService: TranslationService
  ) { }

}
